// Polyfill para CommonJS no navegador
// Necessário para bibliotecas como microsoft-cognitiveservices-speech-sdk
// Este polyfill precisa ser executado antes de qualquer código CommonJS
(function() {
  'use strict';
  
  // Cria um escopo global mínimo para exports e module
  if (typeof window !== 'undefined') {
    if (typeof window.exports === 'undefined') {
      window.exports = {};
    }
    if (typeof window.module === 'undefined') {
      window.module = { exports: window.exports };
    }
  }
  
  // Também define no escopo global para compatibilidade
  if (typeof global !== 'undefined') {
    if (typeof global.exports === 'undefined') {
      global.exports = {};
    }
    if (typeof global.module === 'undefined') {
      global.module = { exports: global.exports };
    }
  }
})();

